export default __webpack_public_path__ + "static/media/story-SLIDE_3.e546ec42.jpg";